const LABELS = {
    known: 'Known to the bearer',
    'told-when-applied': 'Told when applied',
    hidden: 'Hidden from the bearer',
};

// Mirrors GuideAuraVisibility.AwarenessKey on the server. The fallback keeps a payload predating
// awarenessKey rendering as the two-state split it was built with instead of blanking the chip.
export function awarenessKeyOf(aura) {
    if (aura.awarenessKey && LABELS[aura.awarenessKey]) return aura.awarenessKey;
    return aura.isKnownToBearer ? 'known' : 'hidden';
}

export function awarenessLabelOf(aura) {
    return LABELS[awarenessKeyOf(aura)];
}
